import { ClientsCreateForm } from '../../components/ClientsCreateForm/ClientsCreateForm';
import { ModalLayout } from '../layout/ModalLayout';

interface ClientCreateProps {
  open: boolean;
  onClose: () => void;
}

export const ClientCreateModal = ({ open, onClose }: ClientCreateProps) => {
  return (
    <ModalLayout open={open} onClose={onClose} title="Create Client">
      <ClientsCreateForm onSubmitted={onClose} />
    </ModalLayout>
  );
};
